import React, { createContext, useState, useContext, useEffect } from 'react';
import NetworkAlert from '../components/NetworkAlert';

const NetworkContext = createContext();

export const NetworkProvider = ({ children }) => {
    const [isNetworkError, setIsNetworkError] = useState(false);

    const showNetworkError = () => setIsNetworkError(true);
    const hideNetworkError = () => setIsNetworkError(false);

    useEffect(() => {
        // Listen for network error events
        const handleNetworkError = () => {
            showNetworkError();
        };

        window.addEventListener('network-error', handleNetworkError);

        return () => {
            window.removeEventListener('network-error', handleNetworkError);
        };
    }, []);

    return (
        <NetworkContext.Provider value={{ showNetworkError, hideNetworkError }}>
            {children}
            <NetworkAlert open={isNetworkError} onClose={hideNetworkError} />
        </NetworkContext.Provider>
    );
};

export const useNetwork = () => {
    const context = useContext(NetworkContext);
    if (!context) {
        throw new Error('useNetwork must be used within a NetworkProvider');
    }
    return context;
};

export default NetworkContext; 